<template>
  <div class="wrapper" :class="{ 'sidebar-collapsed': sidebarCollapsed }">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'ventas inex' || rol === 'operaciones' || rol === 'cliente'" :link="{
          name: 'Dashboard',
          path: '/dashboard-master',
          icon: 'fas fa-chart-pie text-primary',
        }">
        </sidebar-item>
        <!-- La ruta /inventario ya permitia 'ventas inex' (routes.js), pero el menu no lo
             mostraba: es la misma inconsistencia que ya paso con 'cliente' (ver comentario
             mas abajo). -->
        <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'cliente' || rol === 'ventas inex'" :link="{
          name: $t('dashboard'),
          path: '/inventario',
          icon: 'fas fa-tachometer-alt text-primary',
        }">
        </sidebar-item>
        <sidebar-item v-if="esSoloLectura || rol == 'admin'" :link="{
          name: $t('analytics_title'),
          icon: 'fas fa-chart-line text-primary',
        }">
          <sidebar-item :link="{ name: $t('analytics_ecommerce_menu'), path: '/analytics' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('log_process_menu'), path: '/log-process' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('traduccion_menu'), path: '/traduccion-revision' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones'" :link="{ name: $t('entrenamiento_modelo') }">
            <sidebar-item :link="{ name: $t('depuracion_modelo'), path: '/depuracion-modelo' }"></sidebar-item>
          </sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones'" :link="{
          name: $t('usuarios'),
          path: '/usuarios',
          icon: 'fas fa-users text-primary',
        }">
        </sidebar-item>
        <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{
          name: $t('mantenedores'),
          icon: 'fas fa-cogs text-primary',
        }">
          <sidebar-item :link="{ name: $t('mant_paises'), path: '/paises' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_regiones'), path: '/regiones' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_comunas'), path: '/comunas' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_bodegas'), path: '/bodegas' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_unidades'), path: '/unidades-medida' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_condiciones'), path: '/condiciones' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_taxonomias'), path: '/taxonomias' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_imagenes_categorias'), path: '/imagenes-categorias' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_holdings'), path: '/holdings' }"></sidebar-item>
          <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" :link="{ name: $t('mant_tipos_cambio'), path: '/tipos-cambio' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'ventas inex' || rol === 'operaciones'" :link="{
          name: $t('clientes'),
          path: '/clientes',
          icon: 'fas fa-building text-primary',
        }">
        </sidebar-item>
        <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'ventas inex' || rol === 'operaciones'" :link="{
          name: $t('modulos'),
          icon: 'fas fa-th-large text-primary',
        }">
          <sidebar-item :link="{
            name: $t('materiales'),
            path: '/materiales',
            icon: 'fas fa-boxes text-primary',
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('rentabilizacion'),
            path: '/rentabilizacion',
            icon: 'fas fa-money-bill text-primary',
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: $t('clusterizacion'),
            path: '/clusterizacion',
            icon: 'fas fa-layer-group text-primary',
          }">
          </sidebar-item>
          <sidebar-item :link="{
            name: 'E-Commerce',
            path: '/lectura-ventas-inventario',
            icon: 'fas fa-clipboard-list text-primary',
          }">
          </sidebar-item>
        </sidebar-item>
        <sidebar-item v-if="esSoloLectura || rol === 'cliente' || rol == 'admin' || rol === 'ventas inex' || rol === 'operaciones' || rol === 'comprador'" :link="{
          name: $t('transacciones'),
          path: '/visor-transacciones',
          icon: 'fas fa-exchange-alt text-primary',
        }">
        </sidebar-item>
        <!--sidebar-item v-if="rol == 'admin' || rol === 'ventas inex' || rol === 'operaciones'" :link="{
          name: $t('ofertas'),
          path: '/ofertas',
          icon: 'fas fa-tags text-primary',
        }">
        </sidebar-item-->
        <sidebar-item v-if="esSoloLectura || rol == 'admin' || rol === 'ventas inex' || rol === 'operaciones'" :link="{
          name: $t('solicitudes'),
          path: '/solicitudes',
          icon: 'fas fa-clipboard-check text-primary',
        }">
        </sidebar-item>
        <!-- El rol cliente ya tenía permitida la ruta, pero no la veía en el menú. -->
        <sidebar-item v-if="rol === 'comprador' || rol === 'cliente'" :link="{
          name: $t('mis_solicitudes'),
          path: '/mis-solicitudes',
          icon: 'fas fa-clipboard-list text-primary',
        }">
        </sidebar-item>
        <!-- Sin acceso para el rol cliente. -->
        <li v-if="esSoloLectura || rol == 'admin' || rol === 'operaciones' || rol === 'ventas inex'" class="nav-item">
          <a :href="chatarraUrl" class="nav-link">
            <i class="fas fa-recycle text-primary"></i>
            <span class="nav-link-text">{{ $t('ir_a_chatarra') }}</span>
          </a>
        </li>
        <li class="nav-item">
          <a :href="ecommerceUrl" target="_blank" class="nav-link">
            <i class="fas fa-store text-primary"></i>
            <span class="nav-link-text">{{ $t('ir_a_ecommerce') }}</span>
          </a>
        </li>
        <!--sidebar-item v-if="rol == 'admin' || rol === 'ventas inex'" :link="{
          name: $t('clientes'),
          path: '/clientes',
          icon: 'fas fa-user-friends text-primary',
        }"
        </sidebar-item-->
              
      </template>
    </side-bar>
    <div class="main-content">
      <button class="btn-toggle-sidebar" @click="$store.dispatch('setSidebarCollapsed', !sidebarCollapsed)" :title="sidebarCollapsed ? 'Mostrar menú' : 'Ocultar menú'">
        <i :class="sidebarCollapsed ? 'fas fa-chevron-right' : 'fas fa-chevron-left'"></i>
      </button>
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <!-- Barra de título de página (aplica a todas las vistas excepto las que tienen header propio) -->
      <div class="layout-page-header" v-if="pageTitle && !$route.meta.hideLayoutHeader">
        <span class="layout-page-header__title">{{ pageTitle }}</span>
      </div>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <router-view></router-view>
        </fade-transition>
      </div>
      <!--content-footer v-if="!$route.meta.hideFooter"></content-footer-->
    </div>
  </div>
</template>

<script>
import PerfectScrollbar from 'perfect-scrollbar';
import 'perfect-scrollbar/css/perfect-scrollbar.css';
import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
import DashboardContent from './Content.vue';
import { FadeTransition } from 'vue2-transitions';
import utilsService from '@/api/utilsService';

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    DashboardContent,
    FadeTransition
  },
  data() {
    return {};
  },
  computed: {
    rol() {
      return utilsService.getRol();
    },
    sidebarCollapsed() {
      return this.$store.getters.sidebarCollapsed;
    },
    pageTitle() {
      const map = {
        'inventario':              this.$t('inventario_label'),
        'traduccion-revision':     this.$t('traduccion_revision'),
        'depuracion-modelo':       this.$t('depuracion_modelo_titulo'),
        'analytics':               this.$t('analytics_ecommerce_title'),
        'log-process':             this.$t('log_process_title'),
        'usuarios':                this.$t('usuarios'),
        'usuario-crear':           this.$t('usuarios'),
        'usuario-detalle':         this.$t('usuarios'),
        'usuario-perfil':          'Mi Perfil',
        'paises':                  this.$t('mant_paises'),
        'pais-crear':              this.$t('mant_paises'),
        'pais-detalle':            this.$t('mant_paises'),
        'regiones':                this.$t('mant_regiones'),
        'region-crear':            this.$t('mant_regiones'),
        'region-detalle':          this.$t('mant_regiones'),
        'comunas':                 this.$t('mant_comunas'),
        'comuna-crear':            this.$t('mant_comunas'),
        'comuna-detalle':          this.$t('mant_comunas'),
        'bodegas':                 this.$t('mant_bodegas'),
        'bodega-crear':            this.$t('mant_bodegas'),
        'bodega-detalle':          this.$t('mant_bodegas'),
        'unidades-medida':         this.$t('mant_unidades'),
        'unidad-medida-crear':     this.$t('mant_unidades'),
        'unidad-medida-detalle':   this.$t('mant_unidades'),
        'condiciones':             this.$t('mant_condiciones'),
        'condicion-crear':         this.$t('mant_condiciones'),
        'condicion-detalle':       this.$t('mant_condiciones'),
        'taxonomias':              this.$t('mant_taxonomias'),
        'taxonomia-crear':         this.$t('mant_taxonomias'),
        'taxonomia-detalle':       this.$t('mant_taxonomias'),
        'imagenes-categorias':     this.$t('mant_imagenes_categorias'),
        'holdings':                this.$t('mant_holdings'),
        'holding-crear':           this.$t('mant_holdings'),
        'holding-detalle':         this.$t('mant_holdings'),
        'tipos-cambio':            this.$t('mant_tipos_cambio'),
        'tipo-cambio-crear':       this.$t('mant_tipos_cambio'),
        'tipo-cambio-detalle':     this.$t('mant_tipos_cambio'),
        'clientes':                this.$t('clientes'),
        'empresa-crear':           this.$t('clientes'),
        'empresa-detalle':         this.$t('clientes'),
        'materiales':              this.$t('materiales'),
        'materiales-result-file':  this.$t('materiales'),
        'rentabilizacion':         this.$t('rentabilizacion'),
        'clusterizacion':          this.$t('clusterizacion'),
        'LecturaVentasInventario': 'E-Commerce',
        'ClusterDetalle':          this.$t('clusterizacion'),
        'visor-transacciones':     this.$t('transacciones'),
        'ofertas':                 this.$t('ofertas'),
        'solicitudes':             this.$t('solicitudes'),
        'mis-solicitudes':         this.$t('mis_solicitudes'),
      };
      return map[this.$route.name] || '';
    },
    chatarraUrl() {
      return process.env.VUE_APP_CHATARRA_URL || 'https://portalchatarra.inexlink.com';
    },
    ecommerceUrl() {
      const base = process.env.VUE_APP_ECOMMERCE_URL || 'https://ecommerce.inexlink.com';
      const lang = this.$getLanguage();
      return `${base}?lang=${lang}`;
    }
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith('Win');
      if (isWindows) {
        initScrollbar('sidenav');
      }
    },
    applySidebarCollapseByRoute(route) {
      const path = (route && route.path) || '';
      if (path.startsWith('/clusterizacion')) {
        this.$store.dispatch('setSidebarCollapsed', false);
      }
    }
  },
  mounted() {
    this.initScrollbar();
    this.applySidebarCollapseByRoute(this.$route);
  },
  watch: {
    $route(to) {
      this.applySidebarCollapseByRoute(to);
    }
  }
};
</script>

<style scope lang="scss">
/* Eliminar padding heredado del wrapper .header en todas las vistas */
.main-content .header { padding-top: 0 !important; background: none !important; }

/* ── Barra de título de página ─────────────────────────────── */
.layout-page-header {
  background: #5b6abf;
  padding: 26px 28px 26px 64px;
  margin-bottom: 0;
}
.layout-page-header__title {
  font-size: 1.2rem;
  font-weight: 700;
  color: #fff;
}

.icon-mirror {
  transform: scaleX(-1);
  display: inline-block;
  transform-origin: center;
  margin-right: 10%;    
  margin-left: -10%;
}

/* Sidebar toggle button */
.btn-toggle-sidebar {
  position: fixed;
  top: 18px;
  left: 250px;
  transform: translateX(-50%);
  z-index: 1050;
  width: 22px;
  height: 44px;
  background: #ffffff;
  border: 1px solid #dee2e6;
  border-radius: 0 6px 6px 0;
  box-shadow: 2px 0 6px rgba(0,0,0,0.1);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  transition: left 0.3s ease;
  color: #6c757d;
  font-size: 0.75rem;
  width: 32px;
  height: 28px;
}

.btn-toggle-sidebar:hover {
  background: #f0f4ff;
  color: #007bff;
  border-color: #007bff;
}

/* Collapsed state */
.sidebar-collapsed #sidenav-main {
  transform: translateX(-100%);
  width: 0 !important;
  min-width: 0 !important;
  overflow: hidden;
  transition: transform 0.3s ease, width 0.3s ease;
}

.sidebar-collapsed .main-content {
  margin-left: 0 !important;
  transition: margin-left 0.3s ease;
}

.sidebar-collapsed .btn-toggle-sidebar {
  left: 16px;
  transform: none;
  border-radius: 6px;
}

#sidenav-main {
  transition: transform 0.3s ease, width 0.3s ease;
}

.main-content {
  transition: margin-left 0.3s ease;
}
</style>
